export default __webpack_public_path__ + "static/media/icon-settings-myparish.c525ea53.svg";